import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=4706b064&scoped=true&"
import script from "./Parameter.vue?vue&type=script&lang=js&"
export * from "./Parameter.vue?vue&type=script&lang=js&"
import style0 from "./Parameter.vue?vue&type=style&index=0&id=4706b064&lang=scss&scoped=true&"
import style1 from "./Parameter.vue?vue&type=style&index=1&id=4706b064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706b064",
  null
  
)

export default component.exports